"use strict";

var _regeneratorRuntime = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _classCallCheck = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GrpcAuthentication = void 0;

var context_1 = require("@textile/context");

var grpc_connection_1 = require("@textile/grpc-connection");

var hub_threads_client_1 = require("@textile/hub-threads-client");
/**
 * Not for external use. Defines the authorization, authentication, and
 * API scoping methods used by gRPC API client classes such as Users and Buckets.
 *
 * @internal
 */


var GrpcAuthentication = /*#__PURE__*/function (_grpc_connection_1$Gr) {
  _inherits(GrpcAuthentication, _grpc_connection_1$Gr);

  var _super = _createSuper(GrpcAuthentication);

  function GrpcAuthentication() {
    _classCallCheck(this, GrpcAuthentication);

    return _super.apply(this, arguments);
  }

  _createClass(GrpcAuthentication, [{
    key: "withThread",

    /**
     * Scope future API calls to a specific thread.
     * For both Buckets and Threads, many API calls require knowledge
     * about which thread you are making requests against. Use `withThread`
     * to declare your target thread before making those API calls.
     * @param threadId the ID of the thread
     *
     * @example
     * ```@typescript
     * import { Client, ThreadID } from '@textile/hub'
     *
     * async function example (threadID: ThreadID) {
     *   const client = await Client.withThread(threadID)
     * }
     * ```
     */
    value: function withThread(threadID) {
      if (threadID === undefined) return;
      this.context.withThread(threadID);
    }
    /**
     * Obtain a token for interacting with the remote API.
     * When your app is creating new private-key based users to interact with
     * the API using User Group keys, you must first create a new token for
     * each new user. Tokens do not change after you create them.
     * @param identity A user identity to use for interacting with APIs.
     *
     * @example
     * ```@typescript
     * import { Client, PrivateKey } from '@textile/hub'
     *
     * async function example (client: Client, identity: PrivateKey) {
     *   const token = await client.getToken(identity)
     *   return token
     * }
     * ```
     */

  }, {
    key: "getToken",
    value: function getToken(identity) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var client, token;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                client = new hub_threads_client_1.Client(this.context);
                _context.next = 3;
                return client.getToken(identity);

              case 3:
                token = _context.sent;
                this.context.withToken(token);
                return _context.abrupt("return", token);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Obtain a token for interacting with the remote API.
     * When your app is creating new private-key based users to interact with
     * the API using User Group keys, you must first create a new token for
     * each new user. Tokens do not change after you create them. This callback
     * method will require you to handle challenge signing.
     * @param identity A user identity to use for interacting with buckets.
     * @param callback A callback function that takes a `challenge` argument and returns a signed
     * message using the input challenge and the private key associated with `publicKey`.
     * @note `publicKey` must be the corresponding public key of the private key used in `callback`.
     *
     * @example
     * ```typescript
     * import { Client, PrivateKey } from '@textile/hub'
     *
     * async function example (client: Client, identity: PrivateKey) {
     *   const token = await client.getTokenChallenge(
     *     identity.pubKey,
     *     (challenge: Uint8Array) => {
     *       return new Promise((resolve, reject) => {
     *         // This is where you should program PrivateKey to respond to challenge
     *         // Read more here: https://docs.textile.io/tutorials/hub/production-auth/
     *       }
     *     }
     *   )
     *   return token
     * }
     * ```
     */

  }, {
    key: "getTokenChallenge",
    value: function getTokenChallenge(publicKey, callback) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var client;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                client = new hub_threads_client_1.Client(this.context);
                return _context2.abrupt("return", client.getTokenChallenge(publicKey, callback));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }], [{
    key: "copyAuth",

    /**
     * Copies the full scope and authentication from one API instance to this one.
     * This will copy any existing authentication and authorization info, including:
     *
     *   - Information created withKeyInfo and withUserAuth.
     *
     *   - Any token generated from getToken or getTokenChallenge.
     *
     *   - If you scoped the instance to a specific thread using withThread
     *
     * @param auth any authenticated API class such as Users or Buckets.
     *
     * @example
     * Copy an authenticated Users api instance to Buckets.
     * ```typescript
     * import { Buckets, Users } from '@textile/hub'
     *
     * const usersToBuckets = async (user: Users) => {
     *   const buckets = Buckets.copyAuth(user)
     *   return buckets
     * }
     * ```
     *
     * @example
     * Copy an authenticated Buckets api instance to Users.
     * ```typescript
     * import { Buckets, Users } from '@textile/hub'
     *
     * const bucketsToUsers = async (buckets: Buckets) => {
     *   const user = Users.copyAuth(buckets)
     *   return user
     * }
     * ```
     */
    value: function copyAuth(auth) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new GrpcAuthentication(auth.context, options.debug);
    }
    /**
     * Creates a new API client instance for accessing the gRPC API
     * using User Group key authentication. This method is recommended for
     * public apps where API secrets need to remain hidden from end users.
     * @param auth The UserAuth object.
     *
     * @example
     * ```@typescript
     * import { Client, UserAuth } from '@textile/hub'
     *
     * async function example (userAuth: UserAuth) {
     *   const client = await Client.withUserAuth(userAuth)
     * }
     * ```
     */

  }, {
    key: "withUserAuth",
    value: function withUserAuth(auth) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var context = typeof auth === 'object' ? context_1.Context.fromUserAuth(auth, options.host) : context_1.Context.fromUserAuthCallback(auth, options.host);
      return new GrpcAuthentication(context, options.debug);
    }
    /**
     * Creates a new API client instance for accessing the gRPC API
     * using key & secret based authentication. This method is recommended
     * for admin or insecure implementations where the non-signing keys or
     * key with secret can be embedded directly in an app.
     * @param key The KeyInfo object containing {key: string, secret: string}
     *
     * @example
     * ```@typescript
     * import { Client, KeyInfo } from '@textile/hub'
     *
     * async function start () {
     *   const keyInfo: KeyInfo = {
     *     key: '<api key>',
     *     secret: '<api secret>'
     *   }
     *   const client = await Client.withKeyInfo(keyInfo)
     * }
     * ```
     */

  }, {
    key: "withKeyInfo",
    value: function withKeyInfo(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var context;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                context = new context_1.Context(options.host);
                _context3.next = 3;
                return context.withKeyInfo(key, options.date);

              case 3:
                return _context3.abrupt("return", new GrpcAuthentication(context, options.debug));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    }
  }]);

  return GrpcAuthentication;
}(grpc_connection_1.GrpcConnection);

exports.GrpcAuthentication = GrpcAuthentication;